module.exports = __webpack_public_path__ + "static/media/low-cost.db365c07.png";